<template>
  <div>
    <header class="fixed z-50 w-full bg-white shadow-md">
      <div class="max-w-[1440px] mx-auto px-4 md:px-8 py-4 flex items-center justify-between" style="height: 72px;">
        <div class="flex items-center">
          <a href="#" class="flex items-center gap-2 text-2xl md:text-3xl font-['Pacifico'] text-primary">
            <img class="w-10 h-10" src="logo.png" alt="GREA Logo">
            <span>GREA - Assistant</span>
          </a>
          <nav class="hidden ml-12 md:block">
            <ul class="flex gap-8">
              <li data-aos="fade-down" data-aos-delay="200">
                <button @click="navigateTo('/')" :class="[
                  'text-gray-600 hover:text-primary',
                  activePath === '/' ? 'text-primary' : ''
                ]">{{
  $t('navbar.home') }}</button>
              </li>
              <li data-aos="fade-down" data-aos-delay="200">
                <button @click="navigateTo('/properties')" :class="[
                  'text-gray-600 hover:text-primary',
                  activePath === '/properties' ? 'text-primary' : ''
                ]">{{
  $t('navbar.properties') }}</button>
              </li>
              <li data-aos="fade-down" data-aos-delay="300">
                <button @click="navigateTo('/investment')" :class="[
                  'text-gray-600 hover:text-primary',
                  activePath === '/investment' ? 'text-primary' : ''
                ]">{{
  $t('navbar.investment') }}</button>
              </li>
              <li data-aos="fade-down" data-aos-delay="400">
                <button @click="navigateTo('/about')" :class="[
                  'text-gray-600 hover:text-primary',
                  activePath === '/about' ? 'text-primary' : ''
                ]">{{
  $t('navbar.about') }}</button>
              </li>
              <li data-aos="fade-down" data-aos-delay="500">
                <button @click="navigateTo('/contact')" :class="[
                  'text-gray-600 hover:text-primary',
                  activePath === '/contact' ? 'text-primary' : ''
                ]">{{
  $t('navbar.contact') }}</button>
              </li>
            </ul>
          </nav>
        </div>
        <div class="items-center hidden gap-6 md:flex">
          <div class="relative" data-aos="fade-left" data-aos-delay="100">
            <button @click="isLanguageMenuOpen = !isLanguageMenuOpen"
              class="flex items-center gap-2 text-gray-600 hover:text-primary">
              <i class="flex items-center justify-center w-5 h-5 fas fa-globe"></i>
              <span>{{ $t('language') }}</span>
              <i class="text-xs transition-transform duration-200 fas fa-chevron-down"
                :class="{ 'rotate-180': isLanguageMenuOpen }"></i>
            </button>
            <div class="absolute right-0 z-50 w-32 mt-2 overflow-hidden bg-white rounded-md shadow-lg"
              v-show="isLanguageMenuOpen" @click.stop>
              <div class="py-1">
                <button v-for="lang in availableLanguages" :key="lang.code" @click="switchLanguage(lang.code)"
                  class="block w-full px-4 py-2 text-left text-gray-700 hover:bg-gray-100">
                  {{ lang.name }}
                </button>
              </div>
            </div>
          </div>
          <button class="flex items-center gap-2 text-gray-600 hover:text-primary" @click="jumpTo(1)" data-aos="fade-left"
            data-aos-delay="200">
            <i class="flex items-center justify-center w-5 h-5 fas fa-user"></i>
            <span>{{ $t('components.TheNavbar.375701-0') }}</span>
          </button>
          <button class="flex items-center gap-2 text-gray-600 hover:text-primary" @click="jumpTo(2)" data-aos="fade-left"
            data-aos-delay="250">
            <i class="flex items-center justify-center w-5 h-5 fas fa-user-plus"></i>
            <span>{{ $t('components.TheNavbar.375701-1') }}</span>
          </button>
        </div>
        <button class="text-gray-600 md:hidden" @click="toggleMenu()">
          <i class="text-xl fas fa-bars"></i>
        </button>
      </div>

      <!-- 移动端菜单 -->
      <div id="mobile-menu" v-if="isMobileMenuOpen"
        class="w-full overflow-x-hidden bg-white border-t border-gray-200 md:hidden">
        <div class="px-4 py-2 space-y-3">
          <button @click="navigateTo('/')" :class="[
            'block py-2 font-medium',
            activePath === '/' ? 'text-primary' : 'text-gray-600 hover:text-primary'
          ]">{{ $t('navbar.home') }}</button>
          <button @click="navigateTo('/properties')" :class="[
            'block py-2 font-medium',
            activePath === '/properties' ? 'text-primary' : 'text-gray-600 hover:text-primary'
          ]">{{ $t('navbar.properties') }}</button>
          <button @click="navigateTo('/investment')" :class="[
            'block py-2 font-medium',
            activePath === '/investment' ? 'text-primary' : 'text-gray-600 hover:text-primary'
          ]">{{ $t('navbar.investment') }}</button>
          <button @click="navigateTo('/about')" :class="[
            'block py-2 font-medium',
            activePath === '/about' ? 'text-primary' : 'text-gray-600 hover:text-primary'
          ]">{{ $t('navbar.about') }}</button>
          <button @click="navigateTo('/contact')" :class="[
            'block py-2 font-medium',
            activePath === '/contact' ? 'text-primary' : 'text-gray-600 hover:text-primary'
          ]">{{ $t('navbar.contact') }}</button>
          <hr class="my-2 border-gray-200">

          <div class="py-2">
            <button @click="isLanguageMenuOpen = !isLanguageMenuOpen"
              class="flex items-center gap-2 text-gray-600 hover:text-primary">
              <i class="flex items-center justify-center w-5 h-5 fas fa-globe"></i>
              <span>{{ $t('language') }}</span>
              <i class="text-xs transition-transform duration-200 fas fa-chevron-down"
                :class="{ 'rotate-180': isLanguageMenuOpen }"></i>
            </button>
            <div class="mt-2 overflow-hidden bg-white rounded-md shadow-sm" v-show="isLanguageMenuOpen">
              <div class="py-1">
                <button v-for="lang in availableLanguages" :key="lang.code" @click="switchLanguage(lang.code)"
                  class="block w-full px-4 py-2 text-left text-gray-700 hover:bg-gray-100">
                  {{ lang.name }}
                </button>
              </div>
            </div>
          </div>

          <button @click="jumpTo(1)" class="block w-full py-2 text-left text-gray-600 transition-colors hover:text-primary">
            <i class="mr-2 fas fa-user"></i>{{ $t('components.TheNavbar.375701-0') }}
          </button>
          <button @click="jumpTo(2)" class="block w-full py-2 text-left text-gray-600 transition-colors hover:text-primary">
            <i class="mr-2 fas fa-user-plus"></i>{{ $t('components.TheNavbar.375701-1') }}
          </button>
        </div>
      </div>
    </header>

    <!-- 登录弹窗 -->
    <div id="login-modal" v-if="loginModalVisible"
      class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div class="w-full max-w-md p-8 mx-4 bg-white rounded-lg">
        <div class="flex items-center justify-between mb-6">
          <h2 class="text-2xl font-semibold">{{ $t('components.TheNavbar.375701-0') }}</h2>
          <button @click="hideLoginModal()" class="text-gray-500 hover:text-gray-700">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <form class="space-y-4">
          <div>
            <label class="block mb-2 text-gray-700">{{ $t('components.TheNavbar.375701-2') }}</label>
            <div class="flex">
              <!-- <button type="button" @click="addressPopUp = true"
                class="flex items-center justify-center px-3 py-2 border border-r-0 border-gray-300 bg-gray-50 rounded-l-button">
                {{ areaCode }}
                <i class="ml-1 text-xs fas fa-chevron-down"></i>
              </button> -->
              <input type="Phone" id="phone" v-model="tel"
                class="flex-1 px-4 py-2 border border-gray-300 rounded-r-button focus:outline-none focus:border-primary"
                :placeholder="$t('components.TheNavbar.375701-3')">
            </div>
          </div>
          <div>
            <label class="block mb-2 text-gray-700">{{ $t('components.TheNavbar.375701-4') }}</label>
            <input type="password" id="password" v-model="pwd"
              class="w-full px-4 py-2 border border-gray-300 rounded-button focus:outline-none focus:border-primary"
              :placeholder="$t('components.TheNavbar.375701-5')">
          </div>
          <div class="flex items-center">
            <label class="flex items-center">
              <input type="checkbox" class="mr-2">
              <span class="text-sm text-gray-600">{{ $t('components.TheNavbar.375701-6') }}</span>
            </label>
          </div>
          <button type="button" @click="confirmlogin()"
            class="w-full py-2 text-white bg-primary rounded-button hover:bg-primary/90">
            {{ $t('components.TheNavbar.375701-0') }}
          </button>
        </form>
        <div class="mt-4 text-center">
          <p class="text-gray-600">{{ $t('components.TheNavbar.375701-8') }}
            <button @click="switchToRegister()" class="text-primary hover:text-primary/80">{{
              $t('components.TheNavbar.375701-1') }}</button>
          </p>
        </div>
      </div>
    </div>

    <!-- 注册弹窗 -->
    <div id="register-modal" v-if="registerModalVisible"
      class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div class="w-full max-w-md p-8 mx-4 bg-white rounded-lg">
        <div class="flex items-center justify-between mb-6">
          <h2 class="text-2xl font-semibold">{{ $t('components.TheNavbar.375701-1') }}</h2>
          <button @click="hideRegisterModal()" class="text-gray-500 hover:text-gray-700">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <form class="space-y-4">
          <div class="grid grid-cols-2 gap-4">
            <div>
              <label class="block mb-2 text-gray-700">{{ $t('components.TheNavbar.375701-9') }}</label>
              <input type="text" required id="username" v-model="username"
                class="w-full px-4 py-2 border border-gray-300 rounded-button focus:outline-none focus:border-primary"
                :placeholder="$t('components.TheNavbar.375701-10')">
            </div>
          </div>

          <div>
            <label class="block mb-2 text-gray-700">{{ $t('components.TheNavbar.375701-2') }}</label>
            <div class="flex">
              <button type="button" @click="addressPopUp = true"
                class="flex items-center justify-center px-3 py-2 border border-r-0 border-gray-300 bg-gray-50 rounded-l-button">
                {{ areaCode }}
                <i class="ml-1 text-xs fas fa-chevron-down"></i>
              </button>
              <input type="phone" id="tel" v-model="phone"
                class="flex-1 px-4 py-2 border border-gray-300 rounded-r-button focus:outline-none focus:border-primary"
                :placeholder="$t('components.TheNavbar.375701-11')">
            </div>
          </div>

          <div>
            <label class="block mb-2 text-gray-700">{{ $t('components.TheNavbar.375701-4') }}</label>
            <input type="password" id="registrationPassword" v-model="password"
              class="w-full px-4 py-2 border border-gray-300 rounded-button focus:outline-none focus:border-primary"
              :placeholder="$t('components.TheNavbar.375701-5')">
          </div>

          <div>
            <label class="block mb-2 text-gray-700">{{ $t($t('components.TheNavbar.134230-0')) }}</label>
            <input type="password" id="confirmPassword" v-model="confirmPassword"
              class="w-full px-4 py-2 border border-gray-300 rounded-button focus:outline-none focus:border-primary"
              :placeholder="$t($t('components.TheNavbar.134230-1'))">
          </div>

          <div class="grid grid-cols-2 gap-4">
            <div>
              <label class="block mb-2 text-gray-700">{{ $t('components.TheNavbar.375701-12') }}</label>
              <input type="text" id="invitecode" v-model="inviteCode"
                class="w-full px-4 py-2 border border-gray-300 rounded-button focus:outline-none focus:border-primary"
                :placeholder="$t('components.TheNavbar.375701-13')">
            </div>
          </div>
          <div class="flex items-center">
            <input type="checkbox" class="mr-2" v-model="agreeTerms">
            <span class="text-sm text-gray-600">{{ $t('components.TheNavbar.375701-14') }}<a href="#"
                class="text-primary hover:text-primary/80">{{ $t('components.TheNavbar.375701-15') }}</a>{{
                  $t('components.TheNavbar.375701-16') }}<a href="#" class="text-primary hover:text-primary/80">{{
    $t('components.TheNavbar.375701-17') }}</a></span>
          </div>
          <button type="button" @click="registerUser()"
            class="w-full py-2 text-white bg-primary rounded-button hover:bg-primary/90">{{
              $t('components.TheNavbar.375701-1') }}</button>
        </form>
        <div class="mt-4 text-center">
          <p class="text-gray-600">{{ $t('components.TheNavbar.375701-18') }}
            <button @click="switchToLogin()" class="text-primary hover:text-primary/80">{{
              $t('components.TheNavbar.375701-0') }}</button>
          </p>
        </div>
      </div>
    </div>




    <!-- PC端国家选择弹窗 -->
    <div v-if="addressPopUp" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div class="bg-white rounded-lg shadow-xl w-[500px] max-h-[600px] flex flex-col">
        <!-- 弹窗标题和关闭按钮 -->
        <div class="flex items-center justify-between p-4 border-b border-gray-200">
          <h3 class="text-lg font-medium">{{ $t('components.TheNavbar.528863-0') }}</h3>
          <button @click="addressPopUp = false" class="text-gray-500 hover:text-gray-700">
            <i class="fas fa-times"></i>
          </button>
        </div>

        <!-- 搜索框 -->
        <div class="p-4 border-b border-gray-200">
          <div class="flex items-center gap-2">
            <div class="relative flex-1">
              <input v-model="searchFields" type="text" :placeholder="$t('components.TheNavbar.528863-1')"
                class="w-full px-4 py-2 pr-10 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary" />
              <button v-if="searchFields" @click="searchFields = ''"
                class="absolute text-gray-400 transform -translate-y-1/2 right-3 top-1/2 hover:text-gray-600">
                <i class="fas fa-times"></i>
              </button>
            </div>
            <button @click="onSearch"
              class="px-4 py-2 text-white rounded-md bg-primary hover:bg-primary/90 whitespace-nowrap">
              {{ $t('components.TheNavbar.528863-4') }}
            </button>
          </div>
        </div>

        <!-- 国家列表 -->
        <div class="flex-1 p-2 overflow-y-auto">
          <!-- 字母索引栏 -->
          <div class="flex flex-wrap justify-center gap-1 mb-2">
            <button v-for="group in sortedCountryList" :key="group.firstChar" @click="scrollToLetter(group.firstChar)"
              class="flex items-center justify-center w-6 h-6 text-sm rounded hover:bg-gray-100">
              {{ group.firstChar }}
            </button>
          </div>

          <!-- 国家列表内容 -->
          <div class="country-list">
            <!-- 原始的国家分组列表 -->
            <template v-if="!searchFields">
              <div v-for="group in sortedCountryList" :key="group.firstChar" :id="`letter-${group.firstChar}`">
                <div class="sticky top-0 px-3 py-1 text-sm font-medium bg-gray-100">
                  {{ group.firstChar }}
                </div>
                <div v-for="country in group.countries" :key="country.name_en" @click="onCountryClick(country)"
                  class="flex justify-between px-4 py-2 cursor-pointer hover:bg-gray-100">
                  <span>{{ country.name_en }}</span>
                  <span class="text-gray-500">{{ country.area_code }}</span>
                </div>
              </div>
            </template>

            <!-- 搜索结果 -->
            <template v-else>
              <div v-if="searchResults.length > 0">
                <div v-for="country in searchResults" :key="country.name_en" @click="onCountryClick(country)"
                  class="flex justify-between px-4 py-2 cursor-pointer hover:bg-gray-100">
                  <span>{{ country.name_en }}</span>
                  <span class="text-gray-500">{{ country.area_code }}</span>
                </div>
              </div>
              <div v-else class="p-4 text-center text-gray-500">
                {{ $t('components.TheNavbar.528863-2') }}
              </div>
            </template>
          </div>
        </div>

        <!-- 底部按钮 -->
        <div class="flex justify-end p-4 border-t border-gray-200">
          <button @click="addressPopUp = false" class="px-4 py-2 text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200">
            {{ $t('components.TheNavbar.528863-3') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import countryList from '@/utils/country.js'
import navigation from '@/mixins/navigation'
export default {
  name: 'TheNavbar',
  mixins: [navigation],
  data() {
    return {
      isOpen: false,
      tel: '',
      pwd: '',
      username: '',
      phone: '',
      password: '',
      confirmPassword: '',
      inviteCode: '',
      areaCode: '+1',
      agreeTerms: false,
      addressPopUp: false,
      searchFields: '',
      searchResults: [],
      sortedCountryList: [],
      frequentCountries: [

        {
          'area_code': '+61',
          'country_id': 11,
          'name_cn': this.$t('components.TheNavbar.397750-2'),
          'name_en': 'Australia'
        },
        {
          'area_code': '+93',
          'country_id': 244,
          'name_cn': this.$t('components.TheNavbar.397750-3'),
          'name_en': 'Afghanistan'
        },
        {
          'area_code': '+44',
          'country_id': 242,
          'name_cn': this.$t('components.TheNavbar.397750-4'),
          'name_en': 'Britain'
        },
        {
          'area_code': '+98',
          'country_id': 231,
          'name_cn': this.$t('components.TheNavbar.397750-5'),
          'name_en': 'Iran'
        },

        {
          'area_code': '+964',
          'country_id': 232,
          'name_cn': this.$t('components.TheNavbar.397750-6'),
          'name_en': 'Iraq'
        },
        {
          'area_code': '+972',
          'country_id': 237,
          'name_cn': this.$t('components.TheNavbar.397750-7'),
          'name_en': 'Israel'
        },
        {
          'area_code': '+962',
          'country_id': 233,
          'name_cn': this.$t('components.TheNavbar.397750-8'),
          'name_en': 'Jordan'
        },

        {
          'area_code': '+961',
          'country_id': 235,
          'name_cn': this.$t('components.TheNavbar.397750-9'),
          'name_en': 'Lebanon'
        },
        {
          'area_code': '+218',
          'country_id': 240,
          'name_cn': this.$t('components.TheNavbar.397750-10'),
          'name_en': 'Libya'
        },
        {
          'area_code': '+92',
          'country_id': 234,
          'name_cn': this.$t('components.TheNavbar.397750-11'),
          'name_en': 'Pakistan'
        },
        {
          'area_code': '+249',
          'country_id': 239,
          'name_cn': this.$t('components.TheNavbar.397750-12'),
          'name_en': 'Sudan'
        },
        {
          'area_code': '+90',
          'country_id': 177,
          'name_cn': this.$t('components.TheNavbar.397750-13'),
          'name_en': 'Turkey'
        },

        {
          'area_code': '+967',
          'country_id': 238,
          'name_cn': this.$t('components.TheNavbar.397750-14'),
          'name_en': 'Yemen'
        }
      ],
      isMobileMenuOpen: false,
      isLanguageMenuOpen: false,
      loginModalVisible: false,
      registerModalVisible: false,
      // 当前激活的导航路径
      activePath: this.$route.path,
      availableLanguages: [
        { code: 'en', name: 'English' },
        { code: 'fr', name: 'Français' },
        { code: 'pl', name: 'Português' },
        { code: 'ru', name: 'Русский' },
        { code: 'ar', name: 'العربية' },
        { code: 'zh', name: '简体中文' },
        // { code: 'hk', name: '繁體中文' },
        { code: 'ja', name: '日本語' }

      ]
    };
  },
  created() {


    this.groupCountriesByFirstChar()
    this.initializeData()
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
    // 监听路由变化以更新激活状态
    this.$watch('$route', this.onRouteChange);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {


    onCancel() {
      this.searchFields = ''
      this.searchResults = []
      this.addressPopUp = false
    },
    onCountryClick(country) {
      this.areaCode = country.area_code
      this.addressPopUp = false
    },
    scrollToLetter(letter) {
      const element = document.getElementById(`letter-${letter}`)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    },
    groupCountriesByFirstChar() {
      const grouped = {}

      countryList.forEach(country => {
        const firstChar = country.name_en.charAt(0).toUpperCase()

        if (!grouped[firstChar]) {
          grouped[firstChar] = { firstChar, countries: [] }
        }
        grouped[firstChar].countries.push(country)
      })

      this.sortedCountryList = Object.values(grouped).sort((a, b) =>
        a.firstChar.localeCompare(b.firstChar)
      )
    },
    initializeData() {
      // 实现分组逻辑并填充 sortedCountryList
      this.sortedCountryList = countryList.reduce((groups, country) => {
        const firstChar = country.name_en[0].toUpperCase()
        if (!groups[firstChar]) {
          groups[firstChar] = {
            firstChar,
            countries: []
          }
        }
        groups[firstChar].countries.push(country)
        return groups
      }, {})
      this.sortedCountryList = Object.values(this.sortedCountryList)
    },
    onSearch() {
      // 更新搜索逻辑，基于 name_en, area_code, 和 name_cn 进行搜索
      this.searchResults = countryList.filter(country => {
        const searchableString = `${country.name_en} ${country.area_code} ${country.name_cn}`.toLowerCase()
        const searchValue = this.searchFields.toLowerCase()
        return searchableString.includes(searchValue)
      })
      // 自动显示搜索结果
      if (this.searchResults.length > 0) {
        this.$nextTick(() => {
          const firstResult = document.querySelector('.country-list div[class*="cursor-pointer"]')
          if (firstResult) firstResult.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
        })
      }
    },
    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.isLanguageMenuOpen = false;
      }
    },
    switchLanguage(locale) {
      this.$i18n.locale = locale;
      // 处理RTL布局
      if (locale === 'ar') {
        document.documentElement.setAttribute('dir', 'rtl');
      } else {
        document.documentElement.setAttribute('dir', 'ltr');
      }
      // 更新页面标题等需要手动刷新的内容
      document.title = this.$t('navbar.title');
      // 切换语言后关闭菜单
      this.isLanguageMenuOpen = false;
    },
    confirmlogin() {
      const tel = this.tel.trim();
      const pwd = this.pwd.trim();

      if (!tel || !pwd) {
        Swal.fire({
          icon: 'warning',
          title: this.$t('components.TheNavbar.375701-22'),
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
          background: '#fff5f5',
          color: '#d62828',
          customClass: {
            popup: 'rounded-lg shadow-lg'
          }
        });
        return;
      }

      fetch('https://admin.grea-assistant.com/trivago/api/user/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ tel, pwd })
      })
        .then(res => {
          if (!res.ok) throw new Error(this.$t('components.TheNavbar.375701-23'));
          return res.json();
        })
        .then(data => {
          if (data && data.code === 200 && data.result?.token) {
            localStorage.setItem('token', data.result.token);
            Swal.fire({
              icon: 'success',
              title: this.$t('components.TheNavbar.375701-24'),
              text: this.$t('components.TheNavbar.375701-25'),
              timer: 1500,
              showConfirmButton: false,
              background: '#f0fdf4',
              color: '#16a34a',
              customClass: {
                popup: 'rounded-lg shadow-lg'
              }
            }).then(() => {
              window.location.href = 'https://greassistant.com/#/login?token=' + data.result.token;
            });
          } else {
            Swal.fire({
              icon: 'error',
              title: this.$t('components.TheNavbar.375701-26'),
              text: data.msg || this.$t('components.TheNavbar.375701-27'),
              background: '#fef2f2',
              color: '#dc2626',
              confirmButtonColor: '#d62828',
              customClass: {
                popup: 'rounded-lg shadow-lg'
              }
            });
            console.error(this.$t('components.TheNavbar.375701-28'), data);
          }
        })
        .catch(err => {
          Swal.fire({
            icon: 'error',
            title: this.$t('components.TheNavbar.375701-29'),
            text: err.message,
            background: '#fef2f2',
            color: '#dc2626',
            confirmButtonColor: '#d62828',
            customClass: {
              popup: 'rounded-lg shadow-lg'
            }
          });
          console.error(this.$t('components.TheNavbar.375701-30'), err);
        });
    },

    toggleMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
    },
    showLoginModal() {
      this.loginModalVisible = true;
      this.registerModalVisible = false;
    },
    hideLoginModal() {
      this.loginModalVisible = false;
    },
    showRegisterModal() {
      this.registerModalVisible = true;
      this.loginModalVisible = false;
    },
    hideRegisterModal() {
      this.registerModalVisible = false;
      // 清空表单
      this.username = '';
      this.phone = '';
      this.password = '';
      this.confirmPassword = '';
      this.inviteCode = '';
      this.areaCode = '+1';
      this.agreeTerms = false;
    },
    switchToRegister() {
      this.loginModalVisible = false;
      this.registerModalVisible = true;
      // 清空表单
      this.username = '';
      this.phone = '';
      this.password = '';
      this.confirmPassword = '';
      this.inviteCode = '';
      this.areaCode = '+1';
    },
    switchToLogin() {
      this.registerModalVisible = false;
      this.loginModalVisible = true;
      // 清空表单
      this.tel = '';
      this.pwd = '';
    },
    // 路由变化时更新激活路径
    onRouteChange(to) {
      this.activePath = to.path;
    },
    // 统一导航方法
    navigateTo(path) {
      this.activePath = path;
      this.$router.push(path).catch(err => {
        // 忽略重复导航到相同路由的错误
        if (err.name !== 'NavigationDuplicated') {
          throw err;
        }
      });
      this.isMobileMenuOpen = false;
    },
    registerUser() {
      const username = this.username.trim();
      const phone = this.phone.trim();
      const country = this.areaCode;
      const password = this.password.trim();
      const confirmPassword = this.confirmPassword.trim();
      const inviteCode = this.inviteCode.trim();

      if (!username || !phone || !password || !confirmPassword || !inviteCode || !country) {
        Swal.fire({
          icon: 'warning',
          title: this.$t('components.TheNavbar.375701-31'),
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
          background: '#fff5f5',
          color: '#d62828',
          customClass: {
            popup: 'rounded-lg shadow-lg'
          }
        });
        return;
      }

      if (!this.agreeTerms) {
        Swal.fire({
          icon: 'warning',
          title: this.$t('components.TheNavbar.134230-2'),
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
          background: '#fff5f5',
          color: '#d62828',
          customClass: {
            popup: 'rounded-lg shadow-lg'
          }
        });
        return;
      }

      if (password !== confirmPassword) {
        Swal.fire({
          icon: 'error',
          title: this.$t('components.TheNavbar.134230-3'),
          text: this.$t('components.TheNavbar.134230-4'),
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
          background: '#fff5f5',
          color: '#d62828',
          customClass: {
            popup: 'rounded-lg shadow-lg'
          }
        });
        return;
      }

      fetch('https://admin.grea-assistant.com/trivago/api/user/register', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          userName: username,
          tel: phone,
          pwd: password,
          country: country,
          inviteCode: inviteCode,
          browserId: 'web'
        })
      })
        .then(res => {
          if (!res.ok) throw new Error(this.$t('components.TheNavbar.375701-23'));
          return res.json();
        })
        .then(data => {
          if (data && data.code === 200) {
            Swal.fire({
              icon: 'success',
              title: this.$t('components.TheNavbar.375701-32'),
              text: this.$t('components.TheNavbar.375701-33'),
              timer: 1500,
              showConfirmButton: false,
              background: '#f0fdf4',
              color: '#16a34a',
              customClass: {
                popup: 'rounded-lg shadow-lg'
              }
            }).then(() => {
              window.location.href = 'index.html';
            });
          } else {
            Swal.fire({
              icon: 'error',
              title: data.message,
              text: data.msg || this.$t('components.TheNavbar.375701-34'),
              background: '#fef2f2',
              color: '#dc2626',
              confirmButtonColor: '#d62828',
              customClass: {
                popup: 'rounded-lg shadow-lg'
              }
            });
            console.error(this.$t('components.TheNavbar.375701-35'), data);
          }
        })
        .catch(err => {
          Swal.fire({
            icon: 'error',
            title: this.$t('components.TheNavbar.375701-29'),
            text: err.message,
            background: '#fef2f2',
            color: '#dc2626',
            confirmButtonColor: '#d62828',
            customClass: {
              popup: 'rounded-lg shadow-lg'
            }
          });
          console.error(this.$t('components.TheNavbar.375701-30'), err);
        });
    },

  }
};
</script>

<style>
/* 增强选择器的特异性来提高优先级 */
nav ul li .active-link,
#mobile-menu .active-link {
  color: #D4AF37 !important;
}

/* PC端国家选择弹窗样式 */
.country-list {
  max-height: 400px;
  overflow-y: auto;
  scrollbar-width: thin;
}

.country-list::-webkit-scrollbar {
  width: 6px;
}

.country-list::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.country-list::-webkit-scrollbar-thumb {
  background: #D4AF37;
  border-radius: 3px;
}

.country-list::-webkit-scrollbar-thumb:hover {
  background: #b39429;
}

/* 区号选择器样式 */
.rounded-l-button {
  border-top-left-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}

.rounded-r-button {
  border-top-right-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
}

.country-list::-webkit-scrollbar-thumb {
  background: #D4AF37;
  border-radius: 3px;
}

.country-list::-webkit-scrollbar-thumb:hover {
  background: #b39429;
}
</style>